'use client';

import Heading from 'src/components/Heading/Heading';
import { Button } from '@get-mosh/msh-shared';
import { trackClick } from 'src/analytics/Events';
import EventNames from 'src/analytics/EventNames';

type BannerProps = {
    title: string;
    btnText: string;
    link: string;
};

const Banner = (data: BannerProps) => {
    return (
        <div className="container">
            <div className="block w-full text-center mb-4">
                <Heading tag="h" level="h2" centered={true} className={'px-4'}>
                    {data.title}
                </Heading>
                <div className="text-center">
                    <Button
                        text={data.btnText}
                        href={data.link}
                        as="a"
                        className={'mb-0'}
                        onClick={() => {
                            trackClick(EventNames.BUTTON_CLICKED, {
                                label: data.btnText,
                                link: data.link,
                                location: 'banner',
                            });
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Banner;
